import { STOCK_STATUS_PRIORITY } from "@features/product/config/const";

export function isInStock(stock: number, stockNumber: number | null) {
  if (stockNumber === 0) return false;
  return (
    stock === STOCK_STATUS_PRIORITY.StockItem ||
    stock === STOCK_STATUS_PRIORITY.PendingSoldOut ||
    stock === STOCK_STATUS_PRIORITY.PendingOutOfStock
  );
}
